import React, { useState } from "react";
import { Person } from "models/Person";
import { Account } from "models/Account";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updatePerson } from 'storeAccount/actions/Customers';
import { Alert } from "reactstrap";
import { PersonsState } from 'storeAccount/reducers/Persons';
import { RootStateAccount } from "storeAccount/accountStore";
import { accountLocaleOptions, normalizeAccountLocale, useAccountTranslation } from "../translations";


interface Props {
    person: Person;
    customer: Account;
    onCancel: () => void;
    setPerson: (p: Person) => void;
    save: () => void;
    personsState: PersonsState;
}

interface Actions {
    updatePerson: typeof updatePerson;
}

const CustomerPersonAdd: React.FC<Props & Actions> = ({ personsState, customer, person, onCancel, save, updatePerson, setPerson }) => {

    const [error, setError] = useState<string | null>(null)
    const { t } = useAccountTranslation();
    const savePerson = () => {

        if (person.name === "" || person.name === undefined) {
            setError(t("personNeedsName"))
        } else {
            updatePerson(person)
                //@ts-ignore
                .then((person) => {
                    setPerson(person);
                    save();
                })
        }
    }

    return (
        <>
            {
                error &&
                <Alert color="danger">{error}</Alert>
            }

            <br />
            <div className="form-floating mb-3">
                <button type="button"
                    onClick={() => {
                        onCancel();
                    }}
                    className="btn btn-danger waves-effect waves-light">
                    {t("cancel")}
                </button>
            </div>

            <div className="form-floating mb-3">
                <input type="text" name="nameperson" className="form-control" defaultValue={person.name} onChange={e => {
                    person.name = e.target.value

                }} placeholder={t("firstName")} />
                <label className="">{t("firstName")}</label>
            </div>
            <div className="form-floating mb-3">
                <input type="text" name="lastnameperson" className="form-control" defaultValue={person.last_name} onChange={e => {
                    person.last_name = e.target.value

                }} placeholder={t("lastName")} />
                <label className="">{t("lastName")}</label>
            </div>


            <div className="form-floating mb-3">
                <input type="text" name="phoneperson" className="form-control" defaultValue={person.phone} onChange={e => {
                    person.phone = e.target.value

                }} placeholder={t("phone")} />
                <label className="">{t("phone")}</label>
            </div>

            <div className="form-floating mb-3">
                <select
                    name="localeperson"
                    className="form-select"
                    defaultValue={normalizeAccountLocale(person.locale)}
                    onChange={event => {
                        person.locale = event.target.value
                    }}
                    aria-label={t("language")}
                >
                    {accountLocaleOptions.map(option =>
                        <option key={option.value} value={option.value}>{t(option.labelKey)}</option>
                    )}
                </select>
                <label className="">{t("language")}</label>
            </div>

            <div className="mt-3">
                <button
                    id="buttonPerson"
                    name="buttonPerson"
                    type="button"
                    onClick={() => {
                        savePerson()
                    }}
                    className="btn btn-primary w-100 waves-effect waves-light"
                >
                    <i className="mdi mdi-account-plus"></i> {t("save")}
                </button>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootStateAccount) => {
    return {
        personsState: state.Persons
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ updatePerson }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerPersonAdd);
